import { render } from "./ShopModalService.vue?vue&type=template&id=ac4221dc"
import script from "./ShopModalService.vue?vue&type=script&lang=js"
export * from "./ShopModalService.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vixfs/PhpstormProjects/fitbase/frontend/web/vue-resources/personal-account/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__